<!--资源中心菜单-->
<template>
    <div class="menu-container">
        <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">课题引领</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">教研赛事</div>
        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">专题活动</div>
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">档案管理</div>
        <!-- <div @click="changeItem('5')" :class="activeItem==='5'?'menu-item menu-active':'menu-item'">教学分析报告</div> -->
    </div>
</template>

<script>

export default {
    name:'eduResearchMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"1",
            isAnalyse: this.$storage.get("isAnalyse"),
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },
    }
}

</script>

<style scoped>
.menu-container{
    display: inline-flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}
.menu-item{
    height: 38px;
    line-height: 38px;
    padding: 0 22px;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    color: #1f5aa8;
    background: #fff;
    border: 1px solid #bfd8f2;
    border-radius: 19px;
    cursor: pointer;
    white-space: nowrap;
}
.menu-active{
    background: #0d55a4;
    border-color: #0d55a4;
    color: #fff;
}
</style>